import React, { useEffect, useState } from "react";
import { useStyles } from "./styles";
import Container from '@material-ui/core/Container';
//import Typography from "@material-ui/core/Typography";
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
// Card add
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import * as actions from "../../../store/actions";
import { Alert, Loader, NoData } from '../../../components'
import { connect } from "react-redux";
import { BGImageProjects } from "../../../assets/images/images";
import "../scss/general.scss";
import "../scss/home.scss";
import "../scss/projects.scss";
import { useLocation } from "react-router";
import { Helmet } from "react-helmet";
// interface TabPanelProps {
//     children?: ReactNode;
//     index: number;
//     value: number;
// }

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={{ xs: 0, sm: 0, md: 0, lg: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function Projects(props) {
    const theme = useTheme();
    const classes = useStyles();
    const { cmsReducer } = props
    const { error, loading, success, projectList, projectChildCategories } = cmsReducer
    const { query } = useLocation();
    let url = props?.location?.pathname.split("/");
    let id = url[url?.length - 1];
    const [value, setValue] = useState((query != null && query != undefined && query >= 0) ? query : 0);
 
    const handleChangeIndex = (index) => {
        setValue(index);
    };

    useEffect(() => {
        if (query != null && query != undefined && query >= 0)
            setValue(query);

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [query, props.location.key]);

    useEffect(() => {
        if(projectChildCategories && projectChildCategories?.data.length){
            let categoryId = null;
            let index = (query != null && query != undefined && query >= 0) ? query : value
            categoryId = projectChildCategories?.data[index]._id;
            fetchProjects(categoryId);
        }
    }, [projectChildCategories?.data, query]);

    const handleOnClick = (item) => {
        if(item){
            fetchProjects(item._id);
        }
    };
    
    useEffect(() => {
        if (id) {
            fetchProjectChildCat(id);
        }
    }, [props.location.pathname, id]);

    const projectDetails = (item) => {
        props.history.push({ pathname: `/project-details/${item._id}` });
    }

    const fetchProjects = (categoryId) => {
        props.getProjectListStart({ categoryId });
    }
    const fetchProjectChildCat = (parentId) => {
        props.getProjectChildCatStart({ parentId });
    }
    // Tabs opening logic
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Tabs opening logic

    return (
        <div>
            <section className="sub-page-overlay-banner" style={{ backgroundImage: `url("${BGImageProjects}")` }}>
                <span className="sub-page-overlay-effect"></span>
                <Container fixed>
                    <Box className="sub-page-overlay-banner-outer" display="flex" justifyContent="center" textAlign="center" flexDirection="column">
                        <h2 className="sub-page-overlay-banner-heading">
                            WAPDA <span>PROJECTS</span>
                        </h2>
                        <span className="subpage-overlay-banner-span"> Hydropower & Water </span>
                    </Box>
                </Container>
            </section>
            {
                (projectChildCategories?.data?.length) ?
                    <Container fixed className="tab-proje-outer">
                        <Grid container spacing={2} >
                            <Grid item xs={12} lg={12}>
                                <Box sx={{ width: '100%' }} className="box-pad-detail">
                                    <Tabs className={classes.tabs} value={value} onChange={handleChange} TabIndicatorProps={{ style: { display: 'none', transition: 'none' } }} aria-label="basic tabs example">
                                        
                                        {(projectChildCategories?.data?.length) ?
                                            (projectChildCategories?.data || []).map((item, key) => (
                                                <Tab className="tab-btn-detail" label={`${item.description} (${item.totalData})`} {...a11yProps(key)} id={item._id} onClick={() => handleOnClick(item)} />
                                            ))
                                        :
                                            <Loader />
                                            // <NoData text={"No data found"} />
                                        };
                                    </Tabs>
                                </Box>
                                <SwipeableViews
                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                >
                                    <TabPanel value={value} index={0}>
                                        <Helmet>
                                            <title>{'WAPDA Operated and Maintained - WAPDA PROJECTS'}</title>
                                            <meta name='description' content='5 Barrages, 8 inter-river Link Canals (1965 – 70), Mangla (1967) and Tarbela Dams (1976) have been completed by WAPDA Water Wing, and are contributing towards national economy' />
                                            <meta name="keywords" content='WAPDA PROJECTS, WAPDA Operated and Maintained, WAPDA Latest News, WAPDA, 5 Barrages, 8 inter-river Link Canals (1965 – 70), Mangla (1967), Tarbela Dams (1976), wapda Pakistan, wapda electricity, wapda online jobs,' />
                                        </Helmet>
                                        <div>
                                            {
                                                (loading) ? <Loader />
                                                :
                                                (projectList && projectList?.data.length) ?
                                                    <Grid className="project-image-grid" container spacing={3}>
                                                        {(projectList?.data || []).map((item) => {
                                                            return (
                                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                                    <div onClick={() => projectDetails(item)} className="project-image-outer">
                                                                        <img  loading="lazy" className="project-image img-full object-fit" src={item?.thumbnail?.completedUrl}></img>
                                                                        <div className="positionAbsolute tooltip-outer">
                                                                            <div className="tooltip top" role="tooltip"> 
                                                                                <div className="tooltip-arrow"></div> 
                                                                                <div className="tooltip-inner"> {item?.title} </div> 
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Grid>
                                                            )
                                                        })}
                                                    </Grid>
                                                :
                                                    <Loader />
                                                // <NoData text={"No data found"} />

                                            }
                                        </div>
                                    </TabPanel>
                                    <TabPanel value={value} index={1}>
                                        <div>
                                            <Helmet>
                                                <title>{'WAPDA PROJECTS - WAPDA Hydropower and Water Sector'}</title>
                                                <meta name='description' content='The Hydropower  Projects which are currently under construction include: Golen Gol Hydropower Project, Neelum Jhelum, Tarbela 4th extension and amp; Keyal Khwar HPP, whereas Contracting for Stage-I of Dasu HPP is in progress.' />
                                                <meta name="keywords" content='WAPDA PROJECTS, WAPDA Hydropower and Water Sector, WAPDA Latest News, WAPDA, Water and amp; Power Development Authority Sports, PM CJ DAM Fund, wapda jobs, wapda website, dam fund, wapda news today, wapda Pakistan, wapda electricity, wapda online jobs,' />
                                            </Helmet>

                                            {
                                                (loading) ? <Loader />
                                                :
                                                (projectList && projectList?.data.length) ?
                                                    <Grid className="project-image-grid" container spacing={3}>
                                                        {(projectList?.data || []).map((item) => {
                                                            return (
                                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                                    <div onClick={() => projectDetails(item)} className="project-image-outer">
                                                                        <img loading="lazy" className="project-image img-full object-fit" src={item?.thumbnail?.completedUrl}></img>
                                                                        <div className="positionAbsolute tooltip-outer">
                                                                            <div className="tooltip top" role="tooltip"> <div className="tooltip-arrow"></div> <div className="tooltip-inner"> {item?.title} </div> </div>
                                                                        </div>
                                                                    </div>
                                                                </Grid>
                                                            )
                                                        })}
                                                    </Grid>
                                                :
                                                    <Loader /> 
                                                    // <NoData text={"No data found"} />

                                            }
                                        </div>
                                    </TabPanel>
                                    <TabPanel value={value} index={2}>
                                        <div>
                                            <Helmet>
                                                <title>{'WAPDA Upcoming Projects - WAPDA PROJECTS'}</title>
                                                <meta name='description' content='WAPDA has lined up various projects for construction in the coming years include: Dasu Stage-II, Kurram Tangi Dam, Mohmand Dam, Bunji HPP, Tarbela 5th Extension HPP, Phandar HPP, Lower Palas Valley HPP, Lower Spat Gah HPP, Thakot HPP, Basho HPP, and many more.' />
                                                <meta name="keywords" content='WAPDA PROJECTS, WAPDA Upcoming Projects, Dasu Stage-II, Kurram Tangi Dam, Mohmand Dam, Bunji HPP, Tarbela 5th Extension HPP, Phandar HPP, Lower Palas Valley HPP, Lower Spat Gah HPP, Thakot HPP, Basho HPP, wapda jobs,' />
                                            </Helmet>
                                            {
                                                (loading) ? <Loader />
                                                :
                                                (projectList && projectList?.data.length) ?
                                                    <Grid className="project-image-grid" container spacing={3}>
                                                        {(projectList?.data || []).map((item) => {
                                                            return (
                                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                                    <div onClick={() => projectDetails(item)} className="project-image-outer">
                                                                        <img loading="lazy" className="project-image img-full object-fit" src={item?.thumbnail?.completedUrl}></img>
                                                                        <div className="positionAbsolute tooltip-outer">
                                                                            <div className="tooltip top" role="tooltip"> <div className="tooltip-arrow"></div> <div className="tooltip-inner"> {item?.title} </div> </div>
                                                                        </div>
                                                                    </div>
                                                                </Grid>
                                                            )
                                                        })}
                                                    </Grid>
                                                :
                                                    <Loader />
                                                    // <NoData text={"No data found"} />

                                            }
                                        </div>
                                    </TabPanel>
                                    <TabPanel value={value} index={3}>
                                        <div>
                                            {
                                                (loading) ? <Loader />
                                                :
                                                (projectList && projectList?.data.length) ?
                                                    <Grid className="project-image-grid" container spacing={3}>
                                                        {(projectList?.data || []).map((item) => {
                                                            return (
                                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                                    <div onClick={() => projectDetails(item)} className="project-image-outer">
                                                                        <img loading="lazy" className="project-image img-full object-fit" src={item?.thumbnail?.completedUrl}></img>
                                                                        <div className="positionAbsolute tooltip-outer">
                                                                            <div className="tooltip top" role="tooltip"> <div className="tooltip-arrow"></div> <div className="tooltip-inner"> {item?.title} </div> </div>
                                                                        </div>
                                                                    </div>
                                                                </Grid>
                                                            )
                                                        })}
                                                    </Grid>
                                                :
                                                    <Loader />
                                                    // <NoData text={"No data found"} />

                                            }
                                        </div>
                                    </TabPanel>
                                </SwipeableViews>
                            </Grid>
                        </Grid>
                    </Container>
                :
                <Loader />
            }
        </div>
    );
}

//what is needed at start
const mapStateToProps = ({ cmsReducer }) => {
    return { cmsReducer };
};
//which actions our function can dispatch
const mapDispatchToProps = (dispatch) => {
    return {
        getProjectListStart: (data) => dispatch(actions.getProjectList(data)),
        getProjectChildCatStart: (data) => dispatch(actions.getProjectChildCategory(data)),
        cmsMessageHandler: () => dispatch(actions.cmsMessageHandler()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Projects);